import { PortfolioPageShell } from "@/views/Portfolio/shared";
import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";
import type { ExtraTab } from "@/components/Templates/types";
import useIsFeatureFlagEnabled from "@/hooks/useIsFeatureFlagEnabled";
import { useScopeParams } from "@/hooks/useScopeParams";

import PortfolioMetricsView from "./PortfolioMetricsView";
import {
  METRICS_SCREEN_VIEW,
  SCREEN_VIEW_URL_PARAM,
  getEnabledMetricPanels,
} from "./portfolioMetricPanels";

const METRICS_TAB: ExtraTab = {
  type: "custom",
  key: METRICS_SCREEN_VIEW,
  title: "Metrics",
  component: PortfolioMetricsView,
  toolbar: { showOnly: ["workspace", "filters", "guide"] },
};

export default function PortfolioTrials() {
  const { scope, id, buildUrl } = useScopeParams();
  const isFlagEnabled = useIsFeatureFlagEnabled();

  const constants = {
    wikiLink: "",
    idLink: (trialId: string) => buildUrl(`trials/${trialId}`),
  };

  const extraTabs =
    getEnabledMetricPanels(isFlagEnabled).length > 0 ? [METRICS_TAB] : [];

  return (
    <PortfolioPageShell
      title="Portfolio: Trials"
      tooltipText="View all trials in this portfolio with metrics across enrollment, screening, and sites."
    >
      <MetadataDashboardTemplate
        key={`portfolio-trials-${scope}-${id}`}
        type="portfolio-trials"
        constants={constants}
        selectionIdentifierColumn="trial_nct_id"
        extraTabs={extraTabs}
        screenViewUrlParam={SCREEN_VIEW_URL_PARAM}
      />
    </PortfolioPageShell>
  );
}
